module.exports = __webpack_public_path__ + "img/CAMotos.2022c546.png";